import type { Podcast, PodcastDetailPage, PodcastListPage } from '@edwin-group/people-graphql';
import { create } from 'zustand';

interface PodcastDetailState {
  page: PodcastDetailPage | null;
  current: Podcast | null;
  loading: boolean;
  podcastListPage: PodcastListPage | null;
  listeningTime: {
    documentId: string | null;
    id: string | null;
    listeningTime: number;
    duration: number;
  };
}

interface PodcastDetailActions {
  setPage: (page: PodcastDetailPage) => void;
  setCurrent: (podcast: Podcast | null) => void;
  setLoading: (loading: boolean) => void;
  setPodcastListPage: (podcastListPage: PodcastListPage | null) => void;
  setListeningTime: (listeningTime: PodcastDetailState['listeningTime']) => void;
  reset: () => void;
}

const initialState: PodcastDetailState = {
  page: null,
  current: null,
  loading: false,
  podcastListPage: null,
  listeningTime: {
    documentId: null,
    id: null,
    listeningTime: 0,
    duration: 0,
  },
};

export const usePodcastDetailStore = create<PodcastDetailState & PodcastDetailActions>((set) => ({
  ...initialState,
  setPage: (page) => set({ page }),
  setCurrent: (current) => set({ current }),
  setLoading: (loading) => set({ loading }),
  setPodcastListPage: (podcastListPage) => set({ podcastListPage }),
  setListeningTime: (listeningTime) => set({ listeningTime }),
  reset: () =>
    set((state) => ({
      ...initialState,
      podcastListPage: state.podcastListPage,
    })),
}));
